// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"220":"5324f7e71711fbc89545","839":"315bf0a07625ca1a01ed"}[chunkId] + ".css";
};